import React from 'react';
import { motion } from 'framer-motion';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import Select from './Select';
import SearchInput from './SearchInput';

function TableToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filters = [],
  onClearFilters,
  hasActiveFilters = false,
  resultCount,
  totalCount,
  className = '',
}) {
  const { t, formatMessage } = useLanguage();
  const tb = t.common.table;
  const hasSearch = Boolean(onSearchChange);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`toolbar-panel ${className}`}
    >
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        {hasSearch ? (
          <div className="min-w-0 flex-1">
            <SearchInput
              value={searchValue}
              onChange={onSearchChange}
              placeholder={searchPlaceholder || tb.searchPlaceholder}
              aria-label={t.common.search}
            />
          </div>
        ) : null}

        {filters.length > 0 ? (
          <div className="flex flex-wrap items-center gap-2">
            {filters.length > 1 ? (
              <FunnelIcon className="hidden h-4 w-4 text-secondary-400 sm:block" aria-hidden="true" />
            ) : null}
            {filters.map((filter) => (
              <Select
                key={filter.id}
                variant="compact"
                value={filter.value}
                onChange={(e) => filter.onChange(e.target.value)}
                aria-label={filter.label}
              >
                {filter.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            ))}
          </div>
        ) : null}

        {hasActiveFilters && onClearFilters ? (
          <button
            type="button"
            onClick={onClearFilters}
            className="filter-clear-btn shrink-0"
          >
            {tb.clearFilters}
          </button>
        ) : null}
      </div>

      {resultCount !== undefined && totalCount !== undefined ? (
        <p className="toolbar-result-count">
          {formatMessage(tb.showingResults, { count: resultCount, total: totalCount })}
        </p>
      ) : null}
    </motion.div>
  );
}

export default TableToolbar;
